import { render, staticRenderFns } from "./AssistantIconButton.vue?vue&type=template&id=7c60a3a0"
import script from "./AssistantIconButton.vue?vue&type=script&lang=js"
export * from "./AssistantIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports